module["exports"] = {
   SP:{ min:1000000, max: 19999999},
   RJ:{ min:20000000, max: 28999999},
   ES:{ min:29000000, max: 29999999},
   MG:{ min:30000000, max: 39999999},
   BA:{ min:40000000, max: 48999999},
   SE:{ min:49000000, max: 49999999},
   PE:{ min:50000000, max: 56999999},
   AL:{ min:57000000, max: 57999999},
   PB:{ min:58000000, max: 58999999},
   RN:{ min:59000000, max: 59999999},
   CE:{ min:60000000, max: 63999999},
   PI:{ min:64000000, max: 64999999},
   MA:{ min:65000000, max: 65999999},
   PA:{ min:66000000, max: 68899999},
   AP:{ min:68900000, max: 68999999},
   AM:{ min:69400000, max: 69899999},
   RR:{ min:69300000, max: 69389999},
   AC:{ min:69900000, max: 69999999},
   DF:{ min:70000000, max: 73699999},
   GO:{ min:72800000, max: 76799999},
   TO:{ min:77000000, max: 77995999},
   MT:{ min:78000000, max: 78899999},
   MS:{ min:78900000, max: 78999999},
   MS:{ min:79000000, max: 79999999},
   PR:{ min:80000000, max: 87999999},
   SC:{ min:88000000, max: 89999999},
   RS:{ min:90000000, max: 99999999}
}


